import {
  incidentTypesSearchSchema,
  incidentTypesViewColumns,
  mapIncidentTypesViewQuery,
} from "./IncidentTypesView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getIncidentTypes } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface IncidentTypesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function IncidentTypesView(props: IncidentTypesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={incidentTypesViewColumns}
      schema={incidentTypesSearchSchema}
      mapQuery={mapIncidentTypesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getIncidentTypes, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("IncidentTypes", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("IncidentTypes", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default IncidentTypesView;
